const env = process.env;

export const cmpMobileApiList = {
    sendSns: 'cmp/api/sendsns', // 发送短信
    addContact: 'cmp/api/addcountractus' // 保存用户信息
};
export default new Proxy({
    login: 'login',
    auth: 'auth',
    listRule: 'listrule', // 简单规则
    addRule: 'addrule', // 简单规则 - 添加
    deleteRule: 'deleterule', // 简单规则 - 删除
    ...cmpMobileApiList
}, {

    /**
     * 代理每个api路径获取都加上root_api
     * @param  {Object} target 原对象
     * @param  {string} name 要获取的键值
     * @return {string}
     */
    get: (target, name) => {
        return target[name] ? env['ROOT_API'] + '/' + env['MODULE_CMP'] + '/' + target[name] : '';
    }
});



// WEBPACK FOOTER //
// ./src/modules/mobile/constants/api.js